import { useEffect } from 'react'

/**
 * Prevents the page behind an overlay from scrolling while the overlay is open.
 *
 * Without this, reaching the end of the drawer's content hands the scroll to the
 * register underneath — so the scrollbar the user grabs moves the wrong thing,
 * and the form they were filling in slides away.
 *
 * Reference-counted: two overlays can be open at once (the add form can open the
 * vehicle drawer), and the first one to close must not unlock the page while the
 * second is still up.
 */
let lockCount = 0

export function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return

    lockCount += 1
    document.body.classList.add('overlay-open')

    return () => {
      lockCount -= 1
      if (lockCount <= 0) {
        lockCount = 0
        document.body.classList.remove('overlay-open')
      }
    }
  }, [active])
}
